import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { login } from "../../env/action";
import registerImage from "../../assets/registerimage.png";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";

const Login = () => {
  const { userData, setUserData, token, setToken } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    phone_number: Yup.string()
      .required("Phone number is required.")
      .matches(/^[0-9]{10}$/, "Must be 10 digits."),
    password: Yup.string().required("Password is required."),
  });
  const handleLogin = (values, { setSubmitting }) => {
    setLoading(true);

    login(values, (response) => {
      setLoading(false);
      if (response.status === 1) {
        toast.success("Login successful!");
        localStorage.setItem("authToken", response.token);
        localStorage.setItem("userData", JSON.stringify(response.user));
        setUserData(response.user);
        setToken(response.token);
        navigate("/");
      } else {
        toast.error(
          response.message || "Login failed. Please check credentials."
        );
      }
    });
  };

  return (
    <Container className="mt-2 mb-5">
      <Row>
        <Col md={5}>
          <Card className="shadow p-4 mt-5" style={{ borderRadius: "15px" }}>
            <Card.Body style={{ lineHeight: "50px" }}>
              <h2>Login</h2>
              <Formik
                initialValues={{ phone_number: "", password: "" }}
                validationSchema={validationSchema}
                onSubmit={handleLogin}
              >
                {({ handleSubmit, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" style={{ lineHeight: "40px" }}>
                      <Form.Label className="fw-medium">
                        Phone Number
                      </Form.Label>
                      <Field
                        as={Form.Control}
                        name="phone_number"
                        type="text"
                        placeholder="Enter phone number"
                        maxLength={10}
                      />
                      <ErrorMessage
                        name="phone_number"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="fw-medium">Password</Form.Label>
                      <Field
                        as={Form.Control}
                        name="password"
                        type="password"
                        placeholder="Enter password"
                        maxLength={15}
                      />
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>

                    <Button
                      type="submit"
                      className="w-100 mt-3 p-2"
                      variant="primary"
                      disabled={loading || isSubmitting}
                    >
                      {loading ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                          />
                          Logging in...
                        </>
                      ) : (
                        "Login"
                      )}
                    </Button>
                  </Form>
                )}
              </Formik>

              <div className="d-flex justify-content-between mt-3">
                <Link to="/registeruser">Register user Now</Link>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col
          md={7}
          className="d-flex justify-content-center align-items-center"
        >
          <img
            src={registerImage}
            alt="Login"
            className="img-fluid w-75 mt-5"
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
